import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthService from 'service/AuthService';
import "styles/global.css";

const ForgotPasswordSendOtp: React.FC = () => {
  const [email, setEmail] = useState<string>('');
  const [error, setError] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const authService = AuthService();

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    function getDotsAmount(width: number) {
      if (width < 576) return 10;
      if (width < 768) return 15;
      if (width < 992) return 30;
      if (width < 1200) return 35;
      return 40;
    }

    let DOTS_AMOUNT = getDotsAmount(window.innerWidth);
    const MAX_DIST = 150;
    let dots: { x: number; y: number; vx: number; vy: number }[] = [];

    const init = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      dots = [];
      DOTS_AMOUNT = getDotsAmount(window.innerWidth);

      for (let i = 0; i < DOTS_AMOUNT; i++) {
        dots.push({
          x: Math.random() * canvas.width,
          y: Math.random() * canvas.height,
          vx: (Math.random() - 0.5) * 0.5,
          vy: (Math.random() - 0.5) * 0.5,
        });
      }
    };

    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      for (let i = 0; i < dots.length; i++) {
        const dot = dots[i];
        dot.x += dot.vx;
        dot.y += dot.vy;

        if (dot.x < 0 || dot.x > canvas.width) dot.vx *= -1;
        if (dot.y < 0 || dot.y > canvas.height) dot.vy *= -1;

        ctx.beginPath();
        ctx.arc(dot.x, dot.y, 3, 0, Math.PI * 2);
        ctx.fillStyle = "#2B75DA";
        ctx.fill();

        for (let j = i + 1; j < dots.length; j++) {
          const dot2 = dots[j];
          const dist = Math.hypot(dot.x - dot2.x, dot.y - dot2.y);
          if (dist < MAX_DIST) {
            ctx.beginPath();
            ctx.moveTo(dot.x, dot.y);
            ctx.lineTo(dot2.x, dot2.y);
            ctx.strokeStyle = `rgba(0,200,255,${1 - dist / MAX_DIST})`;
            ctx.lineWidth = 1;
            ctx.stroke();
          }
        }
      }
      requestAnimationFrame(animate);
    };

    init();
    animate();

    const handleResize = () => init();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleSendOtp = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      const res = await authService.forgotPasswordSendOtp(email);

      if (res.status === "F") {
        setError(res.message || 'Gagal mengirim OTP');

        if (res.data && typeof res.data === 'string') {
        }
        return;
      }

      localStorage.setItem('resetSessionId', res.data.sessionId);
      localStorage.setItem('resetEmail', email);

      navigate('/forgot-password-verify-otp');
    } catch (err: any) {
      console.error(err);
      setError(err || 'Gagal mengirim OTP. Pastikan email benar.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className="container-fluid position-relative"
      style={{
        height: '100vh',
        overflow: 'hidden',
        background: 'url("/assets/img/background-image.png") center/cover no-repeat',
      }}
    >
      <canvas
        ref={canvasRef}
        id="network"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          display: 'block',
          zIndex: 0,
        }}
      />

      <div className="row h-100 position-relative me-3" style={{ zIndex: 2 }}>
        <div className="col-lg-8 d-none d-lg-flex align-items-center">
          <div
            className="ps-5 ms-5"
            style={{
              color: 'white',
            }}
          >
            <h1 style={{ fontSize: '4rem', fontWeight: '500', marginBottom: '0px', color: '#000' }}>
              Approach <span style={{ color: '#2B75DA' }}>More</span>
            </h1>
            <h1 style={{ fontSize: '4rem', fontWeight: '500', marginBottom: '0px', color: '#000' }}>
              Connect <span style={{ color: '#2B75DA' }}>More</span>
            </h1>
            <h1 style={{ fontSize: '4rem', fontWeight: '500', marginBottom: '0px', color: '#000' }}>
              Achieve <span style={{ color: '#2B75DA' }}>More</span>
            </h1>
          </div>
        </div>

        <div className="col-lg-4 col-md-12 col-sm-12 d-flex align-items-center justify-content-center p-4">
          <div style={{ marginRight: '20px' }}>
            <form onSubmit={handleSendOtp}>
              <img
                src="/assets/logo/logo-transmore-hd-transparent.png"
                className="img-fluid rounded mx-auto d-block"
                alt=""
                style={{ height: '100px', marginBottom: '30px', maxWidth: '80%' }}
              />

              <h1
                className="text-center"
                style={{
                  color: '#2B75DA',
                  fontWeight: 700,
                  marginBottom: '10px',
                  fontSize: '28px',
                }}
              >
                Forgot Password
              </h1>

              <div className="w-100 text-center mb-4">
                <label style={{ color: '#666', fontSize: '15px', lineHeight: '1.5' }}>
                  Enter your email
                </label>
              </div>

              {error && (
                <div className="alert alert-danger text-center" role="alert" style={{
                  padding: '12px',
                  borderRadius: '8px',
                  fontSize: '14px'
                }}>
                  {error}
                </div>
              )}

              <div className="row mt-3">
                <div className="col-12 pb-3">
                  <input
                    id="email"
                    name="email"
                    type="email"
                    className="form-control"
                    placeholder="Email address"
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    disabled={isLoading}
                    style={{
                      padding: '14px 16px',
                      borderRadius: '10px',
                      border: '1px solid #ddd',
                      fontSize: '15px',
                      width: '100%',
                      boxSizing: 'border-box'
                    }}
                  />
                </div>

                <div className="col-12 pb-3">
                  <button
                    type="submit"
                    className="btn btn-primary w-100 fw-semibold"
                    disabled={isLoading}
                    style={{
                      padding: '14px',
                      borderRadius: '10px',
                      backgroundColor: '#2B75DA',
                      border: 'none',
                      fontSize: '16px',
                      transition: 'all 0.3s ease',
                    }}
                    onMouseEnter={(e) => {
                      if (!isLoading) {
                        e.currentTarget.style.backgroundColor = '#1a5cb5';
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        e.currentTarget.style.boxShadow = '0 5px 15px rgba(43, 117, 218, 0.3)';
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!isLoading) {
                        e.currentTarget.style.backgroundColor = '#2B75DA';
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = 'none';
                      }
                    }}
                  >
                    {isLoading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Sending OTP...
                      </>
                    ) : (
                      'Send OTP'
                    )}
                  </button>
                </div>
              </div>

              <div className="text-center mt-4">
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate('/signin');
                  }}
                  style={{
                    color: '#2B75DA',
                    textDecoration: 'none',
                    fontSize: '14px',
                    fontWeight: '500'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.textDecoration = 'underline';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.textDecoration = 'none';
                  }}
                >
                  Back to Login
                </a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordSendOtp;
